module.exports = __webpack_public_path__ + "img/1488563598.977fd712.jpg";